<template>
    <div class="border border-solid rounded-[16px] p-6" :class="appearance.elementColors">
        <div class="flex items-center gap-2">
            <div
                class="w-10 h-8 border-solid border border-white/50 rounded-[16px] text-base flex items-center justify-center"
                :class="appearance.iconColor"
            >
                <font-awesome-icon widthAuto :icon="appearance.icon"></font-awesome-icon>
            </div>
            <div class="text-slate-900 font-semibold capitalize pt-0.5">
                {{ appearance.plural }}
            </div>
        </div>
        <div class="text-slate-500 text-xs mb-6">
            Choose all the {{ appearance.plural }} you want to add to this Flow.
        </div>

        <slot></slot>
    </div>
</template>

<script setup>
import { faContactBook, faMessages, faRobot } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { computed } from 'vue';

const props = defineProps({
    resourceType: {
        type: String,
        validator: (resourceType) => ['automation', 'campaign', 'segment'].includes(resourceType),
        required: true,
    },
});

const appearance = computed(() => {
    if (props.resourceType === 'automation') {
        return {
            plural: 'automations',
            elementColors: 'border-amber-200 bg-amber-50',
            iconColor: 'text-amber-900 bg-amber-300',
            icon: faRobot,
        };
    }
    if (props.resourceType === 'campaign') {
        return {
            plural: 'campaigns',
            elementColors: 'border-sky-200 bg-sky-50',
            iconColor: 'text-sky-900 bg-sky-300',
            icon: faMessages,
        };
    }
    if (props.resourceType === 'segment') {
        return {
            plural: 'segments',
            elementColors: 'border-violet-200 bg-violet-50',
            iconColor: 'text-violet-900 bg-violet-300',
            icon: faContactBook,
        };
    }

    return {};
});
</script>
